import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { Title } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectionListChange } from "@angular/material/list";
import { TranslateService } from "@ngx-translate/core";
import { cloneDeep } from "lodash";
import { EChartOption } from "echarts";

import { Observable, Subscription, zip } from "rxjs";
import { select, Store } from "@ngrx/store";

import { StatusChip, TopCard } from "src/app/models/top-card/top-card.model";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import {
  AppState,
  loadedContractState,
  loadedCustomerPartyListState,
  loadedTenantState,
  getLoadingContractsState,
  contractsStatePlafondMeasurements,
  contractsStatePlafondRules,
  getLoadingPartyState,
  contractsStateProductGroupsListState,
  contractsLimitIntervalsListState,
  contractsLimitMeasurementsListState,
  contractsStateSitesListState,
  contractsStateCreatedContract,
} from "src/app/store/reducers";
import { CustomerPartyDTO } from "src/app/models/Party/customerPartyDTO";
import { getCustomerPartyList } from "src/app/store/actions/parties/parties.actions";
import { ContractDTO } from "src/app/models/Contracts/contractDTO";
import { map, skip } from "rxjs/operators";
import {
  createContract,
  getContract,
  getLimitIntervals,
  getLimitMeasurements,
  getPlafondMeasurements,
  getPlafondRules,
  getProductGroups,
  getProductGroupsList,
  getSitesList,
  resetContract,
  resetContractLimit,
  resetContractPlafond,
  updateContract,
} from "src/app/store/actions/contracts/contracts.actions";
import { FormUtils } from "src/app/shared/utils/formUtils";
import {
  DefaultConfirmationDialogData,
  Dialog,
  GuardConfirmationDialogData,
} from "src/app/models/dialog/dialog.model";
import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";
import {
  CHIP_STYLE,
  getChipStyle,
} from "src/app/shared/utils/customTableUtils";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { ContractPlafondDTO } from "src/app/models/Contracts/contractPlafondDTO";
import { ContractPlafondRuleDTO } from "src/app/models/Contracts/contractPlafondRuleDTO";
import { ContractPlafondMeasurementDTO } from "src/app/models/Contracts/contractPlafondMeasurementDTO";
import { ProductGroupDTO } from "src/app/models/Products/productDTO";
import { SiteDTO } from "src/app/models/Sites/siteDTO";
import { LimitIntervalDTO } from "src/app/models/limits/limitIntervalDTO";
import { LimitMeasurementDTO } from "src/app/models/limits/limitMeasurementDTO";
import { SelectionItem } from "src/app/models/selection-list/selection-list.model";
import { AutocompleteSelectItem } from "src/app/models/selection-list/autocomplete-select-item.model";
import { CanComponentDeactivate } from "src/app/shared";
import { isAuthenticated } from "src/app/shared/utils/authenticationUtils";

//Contract Detail Form
export const FORM_PARAMS = {
  basicData: "basicData",
  enabled: "enabled",
  contractNumber: "contractNumber",
  description: "description",
  customer: "customer",
  startedOn: "startedOn",
  endedOn: "endedOn",
  plafondMeasurement: "plafondMeasurement",
  plafond: "plafond",
  toleranceAllowed: "toleranceAllowed",
  tolerancePlafond: "tolerancePlafond",
  plafondRule: "plafondRule",
  renewalPeriod: "renewalPeriod",
  lastRenewalOn: "lastRenewalOn",
  renewalOn: "renewalOn",
  limits: "limits",
};

@Component({
  selector: "app-contract-detail",
  templateUrl: "./contract-detail.component.html",
  styleUrls: ["./contract-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ContractDetailComponent
  implements OnInit, OnDestroy, CanComponentDeactivate
{
  contractInfoTabs = [
    {
      id: "sub-tab-basic-data",
      description: "Tabs.BasicData",
      icon: "description",
      formParam: FORM_PARAMS.basicData,
      selected: true,
    },
    {
      id: "sub-tab-limits",
      description: "Contracts.Limits",
      icon: "assignment_late",
      formParam: FORM_PARAMS.limits,
      selected: false,
    },
    {
      id: "sub-tab-product-groups",
      description: "Contracts.productGroups",
      icon: "shopping_cart",
      selected: false,
    },
    {
      id: "sub-tab-sites",
      description: "Contracts.sites",
      icon: "local_gas_station",
      selected: false,
    },
  ];

  //Contract
  isLoading$: Observable<boolean>;
  loadedContract$: Observable<ContractDTO>;
  created$: Observable<boolean>;

  statusList = [
    { label: "Status.Active", value: "ACTIVE" },
    { label: "Status.Inactive", value: "INACTIVE" },
  ];

  //top-card configuration
  card: TopCard;
  icon = "add";

  //Subscriptions
  loadedContractSubs: Subscription;
  createdSub: Subscription;
  multiSubs: Subscription;

  // Plafond Measurements List
  plafondMeasurementsList$: Observable<ContractPlafondMeasurementDTO[]>;
  plafondMeasurementsList: SelectionItem[];

  // PlafondRules
  plafondRulesList$: Observable<ContractPlafondRuleDTO[]>;
  plafondRulesList: SelectionItem[];

  //Customers List
  isLoadingCustomer$: Observable<boolean>;
  customersList$: Observable<CustomerPartyDTO[]>;
  customersList: AutocompleteSelectItem[] = [];
  customersSub: Subscription;
  searchTimer: number;

  // Product Groups
  productGroupsList$: Observable<ProductGroupDTO[]>;
  selectedProductGroups: string[];
  productGroupSearchTooltipText: string;

  // Sites
  sitesList$: Observable<SiteDTO[]>;
  selectedSites: string[];
  siteSearchTooltipText: string;

  // Limit Intervals
  limitIntervals$: Observable<LimitIntervalDTO[]>;

  // Limit Measurements
  limitMeasurements$: Observable<LimitMeasurementDTO[]>;

  //Date Time Format
  tenantDataSub: Subscription;
  tenantData$: Observable<any>;
  dateTimeFormat: string;

  //Navigation
  currCode: string;

  currentContract: ContractDTO;

  //Actions
  creation = false;
  duplication = false;

  //Form
  contractDataForm: FormGroup;
  formSubmitted = false;

  //Language
  langSubscription: Subscription;

  // loaded locale
  public locale: string = localStorage.getItem("locale");
  chipList: any[] = [];
  chartOn: boolean = true;

  // Prevent enter key to open date time picker
  @HostListener("keydown", ["$event"])
  onInput(e: KeyboardEvent) {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  }

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
  ) {
    this.titleService.setTitle(this.translate.instant("Contracts.gridTitle"));

    this.tenantData$ = this.store.pipe(select(loadedTenantState));
    this.isLoading$ = this.store.pipe(select(getLoadingContractsState));
    this.isLoadingCustomer$ = this.store.pipe(select(getLoadingPartyState));
    this.loadedContract$ = this.store.pipe(select(loadedContractState));
    this.created$ = this.store.pipe(select(contractsStateCreatedContract));
    this.customersList$ = this.store.pipe(select(loadedCustomerPartyListState));
    this.plafondMeasurementsList$ = this.store.pipe(
      select(contractsStatePlafondMeasurements)
    );
    this.plafondRulesList$ = this.store.pipe(
      select(contractsStatePlafondRules)
    );
    this.productGroupsList$ = this.store
      .pipe(select(contractsStateProductGroupsListState))
      .pipe(
        map((productGroups) => {
          if (productGroups) {
            return productGroups.map((prodGroup) => ({
              code: prodGroup.code ?? null,
              description: prodGroup.detailedDescription[this.locale] ?? null,
              color: prodGroup.color ?? null,
            }));
          }
        })
      );
    this.sitesList$ = this.store
      .pipe(select(contractsStateSitesListState))
      .pipe(
        map((sites) => {
          if (sites) {
            return sites.map((site) => ({
              code: site.code ?? null,
              description: site.description ?? null,
            }));
          }
        })
      );
    this.limitIntervals$ = this.store.pipe(
      select(contractsLimitIntervalsListState)
    );
    this.limitMeasurements$ = this.store.pipe(
      select(contractsLimitMeasurementsListState)
    );

    //initialize card configuration
    this.card = {
      avatarUrl: "",
      content: "",
      imageUrl: "",
      current: "",
      title: "Contracts.newContract",
      subtitle: this.duplication
        ? "Contracts.duplication"
        : "Contracts.creation",
      status: null,
    };
  }
  
  confirmDialog(dialog: any, refresh = false): Observable<boolean> {
    const dialogData: Dialog = GuardConfirmationDialogData;
    const dialogRef = dialog.open(ConfirmationDialogComponent, dialogData);
    if (!refresh) {
      return dialogRef.afterClosed();
    }
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.reload();
      }
    });
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "ignore";

    this.route.params.subscribe((params) => {
      const code = params.id;
      this.creation = false;
      this.duplication = false;
      const duplicateCode = localStorage.getItem("duplicate");

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (code && code.length) {
        this.initialiseState(code, false);
      } else if (duplicateCode !== null) {
        this.duplication = true;
        localStorage.removeItem("duplicate");
        this.initialiseState(duplicateCode, true);
      } else {
        this.creation = true;
        this.initialiseState("", false);
      }
    });

    this.loadTenantDateTimeFomat();
    this.loadLangChanges();

    //Initialize FormGroup
    this.createContractForm();
    this.loadContractInfo();
    this.resetCreation();
    this.setCustomerSearchSubscription();
  }

  resetCreation() {
    this.createdSub = this.created$.pipe(skip(1)).subscribe((created) => {
      if (created) {
        this.creation = false;
        this.duplication = false;
      }
    });
  }

  loadLangChanges() {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant("Contracts.gridTitle"));
    });
  }

  loadTenantDateTimeFomat(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
        if (!this.contractDataForm) {
          return;
        }
        this.setLastRenewalOnField(this.getContractBasicDataForm());
      }
    });
  }

  onSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;
    this.contractInfoTabs = this.contractInfoTabs.reduce((acc, cur) => {
      if (cur.description === description) {
        return [...acc, { ...cur, selected: true }];
      }
      return [...acc, { ...cur, selected: false }];
    }, []);
  }

  createContractForm() {
    this.contractDataForm = this.fb.group({
      [FORM_PARAMS.basicData]: this.fb.group({
        [FORM_PARAMS.enabled]: ["ACTIVE", Validators.required],
        [FORM_PARAMS.contractNumber]: [null, [Validators.maxLength(20)]],
        [FORM_PARAMS.description]: [
          null,
          [
            Validators.required,
            Validators.maxLength(45),
            FormUtils.noWhitespaceValidator,
          ],
        ],
        [FORM_PARAMS.customer]: [
          null,
          [
            Validators.required,
            FormUtils.noWhitespaceValidator,
            FormUtils.isObjectValidator,
          ],
        ],
        [FORM_PARAMS.startedOn]: [null, Validators.required],
        [FORM_PARAMS.endedOn]: [null, Validators.required],
        [FORM_PARAMS.plafondMeasurement]: [null, Validators.required],
        [FORM_PARAMS.plafond]: [null, [Validators.required, Validators.min(0)]],
        [FORM_PARAMS.toleranceAllowed]: [false],
        [FORM_PARAMS.tolerancePlafond]: [
          { value: null, disabled: true },
          Validators.required,
        ],
        [FORM_PARAMS.plafondRule]: [null, Validators.required],
        [FORM_PARAMS.renewalPeriod]: [
          { value: null, disabled: true },
          [Validators.required, Validators.min(1)],
        ],
        [FORM_PARAMS.lastRenewalOn]: [{ value: null, disabled: true }],
        [FORM_PARAMS.renewalOn]: [
          { value: null, disabled: true },
          Validators.required,
        ],
      }),
      [FORM_PARAMS.limits]: this.fb.array([]),
    });
    this.onToleranceChanges(this.getContractBasicDataForm());
    this.onPlafondRuleChanges(this.getContractBasicDataForm());
  }

  getContractBasicDataForm(): FormGroup {
    return <FormGroup>this.contractDataForm.get(FORM_PARAMS.basicData);
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return this.isNavigationAllowed();
  }

  isNavigationAllowed(): Observable<boolean> | boolean {
    if (
      !isAuthenticated(this.router.url) || 
      (this.contractDataForm.pristine &&
      JSON.stringify(this.currentContract?.productGroupCodes) ===
        JSON.stringify(this.selectedProductGroups) &&
      JSON.stringify(this.currentContract?.allowedSites) ===
        JSON.stringify(this.selectedSites))
    ) {
      return true;
    } else {
      return false;
    }
  }

  onToleranceChanges(form: FormGroup): void {
    form
      .get(FORM_PARAMS.toleranceAllowed)
      .valueChanges.subscribe((tolerance) => {
        if (tolerance) {
          form
            .get(FORM_PARAMS.tolerancePlafond)
            .setValidators([Validators.required]);
          form.get(FORM_PARAMS.tolerancePlafond).enable();
        } else {
          form.get(FORM_PARAMS.tolerancePlafond).clearValidators();
          form.get(FORM_PARAMS.tolerancePlafond).updateValueAndValidity();
          form.get(FORM_PARAMS.tolerancePlafond).setValue(null);
          form.get(FORM_PARAMS.tolerancePlafond).disable();
        }
      });
  }

  onPlafondRuleChanges(form: FormGroup): void {
    form.get(FORM_PARAMS.plafondRule).valueChanges.subscribe((plafondRule) => {
      if (plafondRule === "CHECKING_ACCOUNT") {
        this.disableContractRenewals(form, [
          FORM_PARAMS.renewalPeriod,
          FORM_PARAMS.renewalOn,
        ]);
      } else {
        this.enableContractRenewals(form, [
          FORM_PARAMS.renewalPeriod,
          FORM_PARAMS.renewalOn,
        ]);
        form.get(FORM_PARAMS.renewalPeriod).setValidators([Validators.min(1)]);
      }
    });
  }

  disableContractRenewals(form: FormGroup, formFields: string[]) {
    formFields.forEach((field) => {
      form.get(field).clearValidators();
      form.get(field).updateValueAndValidity();
      form.get(field).setValue(null);
      form.get(field).disable();
    });
  }

  enableContractRenewals(form: FormGroup, formFields: string[]) {
    formFields.forEach((field) => {
      form.get(field).setValidators([Validators.required]);
      form.get(field).setValue(null);
      form.get(field).enable();
    });
  }

  setCustomerSearchSubscription() {
    this.customersSub = this.customersList$
      .pipe(skip(1))
      .subscribe((customers) => {
        if (customers) {
          this.customersList = customers.map(
            ({ code, customerCode, name, statusCode, statusDescription }) => {
              return {
                code: code,
                displayCode: customerCode ?? "",
                description: name ?? "",
                statusCode: statusCode ?? "",
                statusDescription: statusDescription ?? "",
              };
            }
          );
        }
      });
  }

  validateFirstCustomerSearch() {
      this.searchCustomers('');
  }

  searchCustomers(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm = typeof event === 'string' ? event : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);

    this.searchTimer = window.setTimeout(
      () => {
        this.store.dispatch(
          getCustomerPartyList({
            options: {
              filteringArgs: {
                filterConfig: [{ field: "customerCode" }, { field: "name" }],
                searchTerms: [searchTerm],
              },
            },
          })
        );
      },
      hasTimer ? 500 : 0
    );
  }

  displayCustomer(customer: {
    code: string;
    displayCode: string;
    description: string;
  }): string {
    return customer?.description ?? "";
  }

  openCustomer() {
    const customerCode =
      this.getContractBasicDataForm().controls[FORM_PARAMS.customer]?.value
        ?.code;
    if (customerCode) {
      return ["/customers/customer", customerCode];
    }
  }

  openPlafondRenewalDialog() {
    const dialogData: Dialog = DefaultConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.store.dispatch(
          resetContractPlafond({
            contractCode: this.currentContract.code,
          })
        );
      }
    });
  }

  loadContractInfo() {
    this.multiSubs = zip(
      this.plafondMeasurementsList$.pipe(skip(1)),
      this.plafondRulesList$.pipe(skip(1))
    ).subscribe(([plafondMeasurements, plafondRules]) => {
      if (plafondMeasurements && plafondMeasurements.length) {
        this.plafondMeasurementsList = plafondMeasurements.map(
          (plafondMeasurement) => {
            return {
              code: plafondMeasurement.code,
              description: plafondMeasurement.detailedDescription[this.locale]
                ? plafondMeasurement.detailedDescription[this.locale]
                : plafondMeasurement?.description,
            };
          }
        );
      }

      if (plafondRules && plafondRules.length) {
        this.plafondRulesList = plafondRules.map((plafondRule) => {
          return {
            code: plafondRule.code,
            description: plafondRule.detailedDescription[this.locale]
              ? plafondRule.detailedDescription[this.locale]
              : plafondRule?.description,
          };
        });
      }

      this.loadedContractSubs = this.loadedContract$.subscribe(
        (contract: ContractDTO) => {
          if (contract) {
            this.currentContract = cloneDeep(contract);

            this.setChipListValues();
            
            const { code, contractNumber, description } = contract;

            if (
              (!this.currCode || (this.currCode && !this.currCode)) &&
              !this.duplication
            ) {
              this.currCode = this.currentContract.code;
            }

            this.card = {
              avatarUrl: "",
              content: "",
              imageUrl: "",
              current: !this.duplication ? code : "",
              title: !this.duplication
                ? `[${contractNumber}] - ${description}`
                : "Contracts.newContract",
              subtitle: !this.duplication
                ? "Contracts.Contract"
                : "Contracts.duplication",
              status: this.setCustomStatusChip(contract) ?? null,
            };

            this.selectedProductGroups = contract.productGroupCodes;
            this.productGroupSearchTooltipText = this.setProductGroupSearchTooltip();
            this.selectedSites = contract.allowedSites;
            this.siteSearchTooltipText = this.setSiteSearchTooltip();

            this.setContractForm(contract);
          }
        }
      );
    });

    this.store.dispatch(getPlafondMeasurements(null));
    this.store.dispatch(getPlafondRules(null));
    this.store.dispatch(getProductGroups(null));
    this.store.dispatch(getLimitIntervals(null));
    this.store.dispatch(getLimitMeasurements(null));
    this.store.dispatch(
      getSitesList({
        options: {
          paging: {
            skip: 0,
            top: 9999,
          },
        },
      })
    );
  }

  checkContractPlafondRule(): boolean {
    return (
      this.currentContract?.contractPlafond?.contractPlafondRuleCode ===
      "CHECKING_ACCOUNT"
    );
  }

  setCustomStatusChip(contract: ContractDTO): StatusChip {
    const { overallStatus } = contract;
    if (!overallStatus) {
      return;
    }

    const { code, description } = overallStatus;
    if (!code) {
      return;
    }

    let style: CHIP_STYLE;
    switch (code) {
      case "ACTIVE":
        style = CHIP_STYLE.SUCCESS;
        break;
      case "DISABLED":
      case "CUSTOMER_INACTIVE":
      case "NOT_STARTED":
      case "EXPIRED":
        style = CHIP_STYLE.INACTIVE;
        break;
      case "LOW PLAFOND":
        style = CHIP_STYLE.WARNING;
        break;
      case "BLOCKED":
      case "CUSTOMER_BLOCKED":
        style = CHIP_STYLE.DANGER;
        break;
      default:
        style = CHIP_STYLE.INACTIVE;
    }

    const styleSettings = getChipStyle(style);
    return {
      value: description,
      style: styleSettings.style,
      icon: styleSettings.icon,
    };
  }

  getCustomerStatusChip() {
    const customer = this.getContractBasicDataForm().controls[FORM_PARAMS.customer]?.value

    if (!customer) {
      return;
    }

    const { statusCode, statusDescription } = customer;
    if (!statusCode || !statusDescription) {
      return;
    }

    const styleSettings = this.setCustomerChipStyle(statusCode);

    return {
      value: statusDescription,
      icon: styleSettings.icon,
      style: styleSettings.style,
    };
  }

  getBasicListStatusChip(statusCode: string) {
    const styleSettings = this.setCustomerChipStyle(statusCode);
    return styleSettings;
  }

  setCustomerChipStyle(partyCustomerStatusCode: string) {
    let style: CHIP_STYLE = CHIP_STYLE.INACTIVE;
    switch (partyCustomerStatusCode) {
      case "ACTIVE":
        style = CHIP_STYLE.SUCCESS;
        break;
      case "DISABLED":
        style = CHIP_STYLE.INACTIVE;
        break;
      case "BLOCKED":
        style = CHIP_STYLE.DANGER;
        break;
    }
    return getChipStyle(style);
  }

  setProductGroupSearchTooltip() {
    const searchTooltipHint = this.translate.instant("SimpleFilter.HintTitle");
    const searchableFields = [this.translate.instant("Products.description")];
    return `${searchTooltipHint}\n${searchableFields.join("\n")}`;
  }

  setSiteSearchTooltip() {
    const searchTooltipHint = this.translate.instant("SimpleFilter.HintTitle");
    const searchableFields = [
      this.translate.instant("SiteManagement.SiteNumber"),
      this.translate.instant("SiteManagement.Description"),
    ];
    return `${searchTooltipHint}\n${searchableFields.join("\n")}`;
  }

  setContractForm(contract: ContractDTO) {
    const contractBasicDataForm = this.getContractBasicDataForm();

    contractBasicDataForm.controls[FORM_PARAMS.enabled].setValue(
      contract?.enabled ? "ACTIVE" : "INACTIVE"
    );
    contractBasicDataForm.controls[FORM_PARAMS.contractNumber].setValue(
      this.duplication ? null : contract?.contractNumber ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.description].setValue(
      this.duplication ? null : contract?.description ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.customer].setValue(
      !contract?.partyCode
        ? null
        : {
            code: contract.partyCode,
            displayCode: contract.partyCustomerCode,
            description: contract.partyName,
            statusCode: contract.partyCustomerStatusCode,
            statusDescription: contract.partyCustomerStatusDescription,
          }
    );
    contractBasicDataForm.controls[FORM_PARAMS.startedOn].setValue(
      contract?.startedOn ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.endedOn].setValue(
      contract?.endedOn ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.plafondMeasurement].setValue(
      contract?.contractPlafond?.contractPlafondMeasurementCode ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.plafond].setValue(
      contract?.contractPlafond?.plafond ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.toleranceAllowed].setValue(
      contract?.contractPlafond?.toleranceAllowed ?? false
    );
    contractBasicDataForm.controls[FORM_PARAMS.tolerancePlafond].setValue(
      contract?.contractPlafond?.tolerancePlafond ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.plafondRule].setValue(
      contract?.contractPlafond?.contractPlafondRuleCode ?? null
    );
    contractBasicDataForm.controls[FORM_PARAMS.renewalPeriod].setValue(
      contract?.contractPlafond.renewalPeriod ?? null
    );

    this.setLastRenewalOnField(contractBasicDataForm);
    contractBasicDataForm.controls[FORM_PARAMS.renewalOn].setValue(
      this.duplication ? null : contract?.contractPlafond?.renewalOn ?? null
    );

    if (!this.duplication) {
      contractBasicDataForm.controls[FORM_PARAMS.customer].disable();
    }
  }

  setLastRenewalOnField(contractForm: FormGroup) {
    contractForm.controls[FORM_PARAMS.lastRenewalOn].setValue(
      this.duplication
        ? null
        : FormUtils.setGivenDateTimePickerFormat(
            this.currentContract?.contractPlafond.lastRenewalOn,
            this.dateTimeFormat ?? "DD/MM/YYYY HH:mm:ss"
          ) ?? null
    );
  }

  setChartOptions(): EChartOption {
    return {
      tooltip: {
        trigger: "item",
        textStyle: {
          fontSize: 12,
        },
        confine: true,
      },
      series: [
        {
          name: this.translate.instant("Contracts.contractProgress"),
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1,
          },
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data:
            !this.creation &&
            !this.duplication &&
            this.currentContract &&
            this.currentContract.contractPlafond
              ? [
                  {
                    value:
                      this.currentContract.contractPlafond.currentlyUsed > 0
                        ? this.currentContract.contractPlafond.currentlyUsed
                        : 0,
                    name: this.translate.instant("Limits.used"),
                    itemStyle: { color: "#858585" },
                  },
                  {
                    value:
                      this.currentContract.contractPlafond.reservedPlafond > 0
                        ? this.currentContract.contractPlafond.reservedPlafond
                        : 0,
                    name: this.translate.instant("Limits.reserved"),
                    itemStyle: { color: "#ffc803" },
                  },
                  {
                    value:
                      this.currentContract.contractPlafond.currentlyOnHand > 0
                        ? this.currentContract.contractPlafond.currentlyOnHand
                        : 0,
                    name: this.translate.instant("Limits.available"),
                    itemStyle: { color: "#3aab40" },
                  },
                ]
              : [{ value: 0, itemStyle: { color: "gray" } }],
        },
      ],
    };
  }

  initialiseState(code: string, duplicate?: boolean) {
    if (code) {
      this.loadContract(code);
      if (duplicate) {
        this.currCode = "";
      } else {
        this.currCode = code;
      }
    } else {
      this.reset();
      this.currCode = "";
      this.card = {
        avatarUrl: "",
        content: "",
        imageUrl: "",
        current: "",
        title: "Contracts.newContract",
        subtitle: this.duplication
          ? "Contracts.duplication"
          : "Contracts.creation",
        status: null,
      };
    }
  }

  loadContract(code: string) {
    if (code) {
      this.store.dispatch(getContract({ contractCode: code }));
    }
  }

  onSubmit() {
    this.formSubmitted = true;

    if (!this.contractDataForm.valid) {
      this.contractDataForm.markAllAsTouched();
      this.snackbarService.show({
        message: this.translate.instant("Contracts.ContractFormInvalid"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    if (
      this.contractDataForm.pristine &&
      !this.creation &&
      !this.duplication &&
      JSON.stringify(this.currentContract.productGroupCodes) ===
        JSON.stringify(this.selectedProductGroups) &&
      JSON.stringify(this.currentContract.allowedSites) ===
        JSON.stringify(this.selectedSites)
    ) {
      this.snackbarService.show({
        message: this.translate.instant("Contracts.NoChanges"),
        type: SnackbarType.WARNING,
      });
      return;
    }   

    const contractBasicDataForm = this.getContractBasicDataForm();
    let contract: ContractDTO = {
      contractNumber:
        contractBasicDataForm.controls[FORM_PARAMS.contractNumber].value ??
        null,
      description:
        contractBasicDataForm.controls[FORM_PARAMS.description].value ?? null,
      partyCode:
        contractBasicDataForm.controls[FORM_PARAMS.customer].value.code ?? null,
      enabled:
        contractBasicDataForm.controls[FORM_PARAMS.enabled].value === "ACTIVE",
      startedOn:
        contractBasicDataForm.controls[FORM_PARAMS.startedOn].value ?? null,
      endedOn:
        contractBasicDataForm.controls[FORM_PARAMS.endedOn].value ?? null,
      contractPlafond: this.setContractPlafond(contractBasicDataForm),
      contractLimits:
        this.contractDataForm.controls[FORM_PARAMS.limits].value ?? null,
      productGroupCodes: this.selectedProductGroups,
      allowedSites: this.selectedSites,
    };

    if (this.currCode.length === 0) {
      this.store.dispatch(createContract({ contract }));
    } else {
      contract = { ...contract, code: this.currCode };
      this.store.dispatch(updateContract({ contract }));
    }

    this.contractDataForm.markAsUntouched();
    this.contractDataForm.markAsPristine();
  }

  setContractPlafond(form: FormGroup): ContractPlafondDTO {
    return {
      contractCode: this.currentContract?.code ?? null,
      contractPlafondRuleCode:
        form.controls[FORM_PARAMS.plafondRule].value ?? null,
      renewalPeriod:
        form.controls[FORM_PARAMS.renewalPeriod].value &&
        form.controls[FORM_PARAMS.renewalPeriod].value > 0
          ? form.controls[FORM_PARAMS.renewalPeriod].value
          : null,
      contractPlafondMeasurementCode:
        form.controls[FORM_PARAMS.plafondMeasurement].value ?? null,
      plafond: form.controls[FORM_PARAMS.plafond].value ?? null,
      renewalOn: form.controls[FORM_PARAMS.renewalOn].value ?? null,
      toleranceAllowed:
        form.controls[FORM_PARAMS.toleranceAllowed].value ?? false,
      tolerancePlafond: form.controls[FORM_PARAMS.toleranceAllowed].value
        ? form.controls[FORM_PARAMS.tolerancePlafond].value ?? 0
        : 0,
    };
  }

  searchProductGroups(searchTerms: string[]) {
    this.store.dispatch(
      getProductGroupsList({
        options: {
          filteringArgs: {
            filterConfig: [{ field: "description" }],
            searchTerms,
          },
        },
      })
    );
  }

  changeSelectedProductGroups(selectedProductGroups: string[]) {
    this.selectedProductGroups = [...selectedProductGroups];
  }

  searchSites(searchTerms: string[]) {
    this.store.dispatch(
      getSitesList({
        options: {
          filteringArgs: {
            filterConfig: [{ field: "siteNumber" }, { field: "description" }],
            searchTerms,
          },
        },
      })
    );
  }

  changeSelectedSites(selectedSites: string[]) {
    this.selectedSites = [...selectedSites];
  }

  openResetContractLimitDialog(limitCode: number) {
    const dialogData: Dialog = DefaultConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.resetContractLimit(limitCode);
      }
    });
  }

  resetContractLimit(limitCode: number) {
    this.store.dispatch(
      resetContractLimit({
        contractCode: this.currCode,
        limitCode: limitCode.toString(),
      })
    );
  }

  changeDataView() {
    this.chartOn = !this.chartOn;
    
    this.setChipListValues();
  }

  setChipListValues() {
    if (!this.chartOn) {
      this.chipList = [];
      const { currentlyOnHand, currentlyUsed, reservedPlafond } =
        this.currentContract.contractPlafond;
      let currentlyOnHandStyle = this.setBasicChipStyle("currentlyOnHand");
      let currentlyUsedStyle = this.setBasicChipStyle("currentlyUsed");
      let reservedPlafondStyle = this.setBasicChipStyle("reservedPlafond");
      this.chipList.push({
        value: !this.duplication ? currentlyOnHand ?? 0 : 0,
        style: currentlyOnHandStyle.style,
        translation: this.translate.instant("Contracts.currentlyOnHand"),
      });
      this.chipList.push({
        value: !this.duplication ? currentlyUsed ?? 0 : 0,
        style: currentlyUsedStyle.style,
        translation: this.translate.instant("Contracts.currentlyUsed"),
      });
      this.chipList.push({
        value: !this.duplication ? reservedPlafond ?? 0 : 0,
        style: reservedPlafondStyle.style,
        translation: this.translate.instant("Contracts.reservedPlafond"),
      });
    }
  }

  setBasicChipStyle(value: string) {
    switch (value) {
      case "currentlyOnHand":
        return {
          style: "background-color: #3aab40; color: white; width:100%",
        };
      case "currentlyUsed":
        return {
          style: "background-color: #858585; color: white;width:100%",
        };
      case "reservedPlafond":
        return {
          style: "background-color: #ffc803; color: color: white; width:100%",
        };
    }
  }

  reset() {
    this.store.dispatch(resetContract());
  }

  back() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.location.back();
  }

  refresh() {
    if (isAuthenticated(this.router.url) && !this.contractDataForm.pristine) {
      this.confirmDialog(this.dialog, true);
      return;
    } else {
      this.reload();
    }
  }
  
  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["contracts/contract", this.currCode]);
  }

  createNew() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/contracts/contract"]);
    this.creation = true;
  }

  duplicate() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    localStorage.setItem("duplicate", this.currCode);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["contracts/contract", {}]);
  }

  ngOnDestroy(): void {
    if (this.createdSub) {
      this.createdSub.unsubscribe();
    }
    if (this.multiSubs) {
      this.multiSubs.unsubscribe();
    }
    if (this.loadedContractSubs) {
      this.loadedContractSubs.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.customersSub) {
      this.customersSub.unsubscribe();
    }
  }
}
